<template>
  <div class="blog-view">
    <v-container>
      <Blog />
    </v-container>
  </div>
</template>
  
<script>
import Blog from "../components/Blog/Blog.vue";
  
export default {
  components: {
    Blog,
  },
};
</script>

<style lang="scss" scoped>
.blog-view {
  width: 100%;
  background: #f5f5f5;
  min-height: 100vh;
  padding: 32px 0;
}

@media (max-width: 600px) {
  .blog-view {
    padding: 24px 0;
  }
}
</style>
  